var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "vs-root" },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        { staticClass: "vs-content" },
        [
          _c(
            "w-sortable",
            {
              attrs: {
                items: _vm.views,
                "disable-x": "",
                "keep-in-y": "",
                "target-class": "handle",
              },
            },
            _vm._l(_vm.views, function (view, i) {
              return _c("div", { key: i, staticClass: "vs-row" }, [
                _c(
                  "span",
                  { staticClass: "vs-grip handle" },
                  [_c("w-fa", { attrs: { icon: "grip-vertical" } })],
                  1
                ),
                _c("span", { staticClass: "vs-name" }, [
                  _vm._v(_vm._s(view.Name || _vm.$ct("missing-name"))),
                ]),
                _vm.showShareButton && !_vm.isOwnedView(view)
                  ? _c("span", { staticClass: "vs-meta" }, [
                      _vm._v(_vm._s(_vm.sharedByText(view))),
                    ])
                  : _vm._e(),
                _vm.showShareButton && _vm.isOwnedView(view)
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-shares"),
                            expression: "$ct('edit-shares')",
                          },
                        ],
                        staticClass: "vs-ib",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.editShares(view)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "users" } })],
                      1
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("edit-view"),
                        expression: "$ct('edit-view')",
                      },
                    ],
                    staticClass: "vs-ib",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.editClicked(view)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "pen" } })],
                  1
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("delete-view"),
                        expression: "$ct('delete-view')",
                      },
                    ],
                    staticClass: "vs-ib del",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteView(view)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ])
            }),
            0
          ),
          _c(
            "button",
            {
              staticClass: "vs-add",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.createNewView()
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(_vm._s(_vm.$ct("view-add")) + " "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditSharesView != null } },
        [
          _vm.toEditSharesView
            ? _c("app-view-share-modal", {
                attrs: { view: _vm.toEditSharesView },
                on: {
                  close: function ($event) {
                    _vm.toEditSharesView = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }